import DatabaseModel from './DatabaseModel.js';

var TipoComponenteProteccion = Object.create(DatabaseModel);

TipoComponenteProteccion.model = 'combos/tiposComponenteProteccion';

export default TipoComponenteProteccion;